// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"76":"common","945":"dashboard"}[chunkId] || chunkId) + "." + {"76":"57c46c6d","93":"0ea6a71b","659":"11324b08","945":"04d69022"}[chunkId] + ".js";
};